import { FormSectionTitle } from '@practium/ui';
import type { PlanningTableData } from '../../utils/planningTableMapper';
import { CollapsibleCard } from '../CollapsibleCard/CollapsibleCard';
import { SimpleDataTable } from '../Tables/SimpleDataTable/SimpleDataTable';
import tabStyles from '../Tabs/TabPanel.module.css';
import styles from './MixturesPanel.module.css';

interface MixtureDemandSectionProps {
	nutrientDemand: PlanningTableData;
	systemRecommendation: PlanningTableData;
}

export const MixtureDemandSection = ({
	nutrientDemand,
	systemRecommendation,
}: MixtureDemandSectionProps) => (
	<div className={tabStyles.section}>
		<FormSectionTitle>Demanda da adubação</FormSectionTitle>
		<div className={styles.collapsibles}>
			<CollapsibleCard title="Demanda de nutrientes para o período">
				<div className={styles.demandTable}>
					<SimpleDataTable
						columns={nutrientDemand.columns}
						rows={nutrientDemand.rows}
						coverageLayout="compact"
					/>
				</div>
			</CollapsibleCard>
			<CollapsibleCard title="Recomendação do sistema">
				<SimpleDataTable columns={systemRecommendation.columns} rows={systemRecommendation.rows} />
			</CollapsibleCard>
		</div>
	</div>
);
